import {
  SDS_PUBLISH_AI_CHECKBOX,
  SDS_PUBLISH_SUPPLIER_CHECKBOX,
} from "@/components/manufacturing/pdf/sdsPdfFooterCopy";
import { mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import type { MfgMaterialSdsDocument } from "@/lib/manufacturing/msdsDocumentTypes";

type Props = {
  draft: MfgMaterialSdsDocument | null;
  publishing: boolean;
  disabled: boolean;
  signOffChecked: boolean;
  onSignOffChange: (checked: boolean) => void;
  onPublish: () => void;
};

/** MSDS-5 — review sign-off checkbox + Publish SDS. */
export function ManufacturingMaterialSdsPublishGate({
  draft,
  publishing,
  disabled,
  signOffChecked,
  onSignOffChange,
  onPublish,
}: Props) {
  if (!draft || draft.status !== "draft") return null;

  const isSupplier = draft.source === "supplier_upload";
  const label = isSupplier ? SDS_PUBLISH_SUPPLIER_CHECKBOX : SDS_PUBLISH_AI_CHECKBOX;

  return (
    <div className="rounded-md border border-gray-200 bg-white px-3 py-3 dark:border-zinc-700 dark:bg-zinc-900">
      <p className="mb-2 text-xs font-semibold text-gray-900 dark:text-zinc-100">Review & publish</p>
      <label className="flex items-start gap-2 text-xs text-gray-800 dark:text-zinc-200">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={signOffChecked}
          onChange={(e) => onSignOffChange(e.target.checked)}
          disabled={disabled || publishing}
        />
        <span>{label}</span>
      </label>
      <div className="mt-3">
        <button
          type="button"
          className={mfgPrimaryBtnClass}
          onClick={onPublish}
          disabled={disabled || publishing || !signOffChecked}
        >
          {publishing ? "Publishing…" : "Publish SDS"}
        </button>
        <p className="mt-1 text-[10px] text-gray-500 dark:text-zinc-400">
          Org admin or owner required. Prior published version is superseded.
        </p>
      </div>
    </div>
  );
}
